import React, { useMemo } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { formatNumber } from '~/utils/helpers'
import { MilkProductionField, StyledLabelError } from '../style'
import InfoPopup from '~/components/InfoPopup'
import { Icon, Popup } from 'semantic-ui-react'

const MilkProduction:React.FC = () => {
  const { t } = useTranslation()
  const { control, formState: { isSubmitted, errors }, setError, clearErrors } = useFormContext()

  const watchCowsNumber = useWatch({ control, name: 'cowsNumber' })
  const watchNaturalMilkAMount = useWatch({ control, name: 'naturalMilkAmount' })

  const milkYealdValue = useMemo(() => {
    const naturalMilk = parseInt(watchNaturalMilkAMount || 0)
    const transformedCowsNumber = watchCowsNumber?.toString()?.replace(',', '.')
    const milkYealdValue = transformedCowsNumber > 0 && !isNaN(transformedCowsNumber) ? Math.floor(naturalMilk / transformedCowsNumber) : 0

    if(milkYealdValue < 3500 || milkYealdValue > 20000) {
      setError('milkProductionYeald', { message: 'error' })
    } else {
      clearErrors('milkProductionYeald')
    }

    return milkYealdValue
  }, [watchNaturalMilkAMount, watchCowsNumber])

  return <>
    <MilkProductionField>
      <label style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
        <div>{t('Milk yield')}</div>
        <InfoPopup
          content={'Automatische Berechnung aus naturaler Milchmenge und  ⌀-Bestand.'}
          styleIcon={{ fontSize: '1.2em' }}
          position={'top center'}
        />
        {(milkYealdValue < 6000 || milkYealdValue > 15000) && <Popup
          content={'Ihre berechnete Milchleistung liegt außerhalb der normalen Bereiche von mind. 6.000kg und maximal 15.000kg pro Kuh und Jahr.'}
          trigger={<Icon name='warning sign' color='yellow' style={{ fontSize: '1.2em' }}/> }
        />}
      </label>
      <div>{`${formatNumber(milkYealdValue, 0)} kg pro Kuh u. Jahr`}</div>
    </MilkProductionField>
    {isSubmitted && errors?.milkProductionYeald && <StyledLabelError
      prompt
      pointing={'above'}>{'Die Milchkeistung muss mindestens 3.500 kg und darf maximal 20.000 kg pro Kuh und Jahr betragen.'}
    </StyledLabelError>}
  </>
}
export default MilkProduction